import fetch from 'cross-fetch';
import { ApiPrefix, json, checkToGetErrorResponse } from 'util/icwUtility';
import { RegistrationTypes } from './types';

// USER_REGISTER
export function userRegisterLoading() {
  return { type: RegistrationTypes.USER_REGISTER.LOADING };
}
export function userRegisterSuccess(data, cb) {
  if (cb) cb(data);
  return { type: RegistrationTypes.USER_REGISTER.SUCCESS, payload: data };
}
export function userRegisterError(error, cbError) {
  if (cbError) cbError(error);
  return { type: RegistrationTypes.USER_REGISTER.ERROR, payload: error };
}
export function userRegister(data, cb, cbError) {
  return (dispatch) => {
    return fetch(`${ApiPrefix}/auth/register`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(checkToGetErrorResponse)
      .then(json)
      .then((res) => {
        dispatch(userRegisterSuccess(res, cb));
      })
      .catch((err) => {
        dispatch(userRegisterError(err ? { message: 'exist_user' } : null, cbError));
      });
  };
}

// USER_VERIFICATION
export function userVerificationLoading() {
  return { type: RegistrationTypes.USER_VERIFICATION.LOADING };
}
export function userVerificationSuccess(data) {
  return { type: RegistrationTypes.USER_VERIFICATION.SUCCESS, payload: data };
}
export function userVerificationError(error) {
  return { type: RegistrationTypes.USER_VERIFICATION.ERROR, payload: error };
}
export function userVerification(data, cb, cbError) {
  return (dispatch) => {
    return fetch(`${ApiPrefix}/auth/verification`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(checkToGetErrorResponse)
      .then(json)
      .then((res) => {
        dispatch(userVerificationSuccess(res));

        if (cb) cb();
      })
      .catch((err) => {
        dispatch(userVerificationError(typeof err === 'object' ? err.message : err));

        if (cbError) cbError();
      });
  };
}

// USER_VERIFICATION_RESEND
export function userVerificationResendLoading() {
  return { type: RegistrationTypes.USER_VERIFICATION_RESEND.LOADING };
}
export function userVerificationResendSuccess(data, cb) {
  if (cb) cb(data);
  return { type: RegistrationTypes.USER_VERIFICATION_RESEND.SUCCESS, payload: data };
}
export function userVerificationResendError(error) {
  return { type: RegistrationTypes.USER_VERIFICATION_RESEND.ERROR, payload: error };
}
export function userVerificationResend(data, cb) {
  return (dispatch) => {
    return fetch(`${ApiPrefix}/auth/resend/verification`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(checkToGetErrorResponse)
      .then(json)
      .then((res) => {
        dispatch(userVerificationResendSuccess(res, cb));
      })
      .catch((err) => {
        dispatch(userVerificationResendError(typeof err === 'object' ? err.message : err));
      });
  };
}
